/**
 * Tidy a stored post excerpt for display.
 *
 * 39 of the 113 excerpts open by repeating the headline verbatim, and 46 carry
 * the "<Title> Introduction Imagine standing on the pristine shores…" run-on
 * left behind by whatever generated them. The old design hid this in small grey
 * text truncated at 35 words; the redesigned masthead shows the excerpt as the
 * standfirst directly under the H1, where a repeated headline is glaring.
 *
 * Cleaning at render time fixes every affected post - on the page, on the cards
 * and in the meta description - without rewriting 113 database rows, and leaves
 * well-written excerpts exactly as they are.
 */

const normalise = (s: string) => s.toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();

export function cleanExcerpt(
  title: string | undefined,
  excerpt: string | null | undefined,
  limit = 240,
): string {
  let s = (excerpt || "").replace(/\s+/g, " ").trim();
  if (!s) return "";

  // Drop a leading repeat of the headline, comparing punctuation-insensitively
  // so "Chinaman's Hat Beach: Your Guide…" still matches "Chinamans Hat Beach…".
  const t = title ? normalise(title) : "";
  if (t && normalise(s).startsWith(t)) {
    let i = 0;
    let seen = "";
    while (i < s.length && normalise(seen).length < t.length) {
      seen += s[i];
      i += 1;
    }
    s = s.slice(i).replace(/^[\s:.\-–—]+/, "");
  }

  s = s.replace(/^(introduction|overview)\b[:\s\-]*/i, "");
  if (s.length <= limit) return s;

  // Prefer a sentence boundary; fall back to a word boundary with an ellipsis.
  const cut = s.slice(0, limit);
  const ends: number[] = [];
  const re = /[.!?]\s/g;
  let m: RegExpExecArray | null;
  while ((m = re.exec(cut)) !== null) ends.push(m.index + 1);
  const lastEnd = ends[ends.length - 1];
  if (lastEnd !== undefined && lastEnd > limit * 0.5) return cut.slice(0, lastEnd).trim();

  const space = cut.lastIndexOf(" ");
  return (space > 0 ? cut.slice(0, space) : cut).replace(/[\s,;:.]+$/, "") + "…";
}
